var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: (_vm.prefixCls + "-timeline-con")
  }, [(_vm.value) ? _vm._l((_vm.value), function(i) {
    return _c('n3-timeline-item', {
      key: _vm.index,
      attrs: {
        "color": i.color,
        "icon": i.icon
      }
    }, [_c('render', {
      attrs: {
        "context": _vm.context || _vm.$parent._self,
        "template": i.content
      }
    })], 1)
  }) : [_vm._t("default")]], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6afa173a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afa173a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Timeline/n3Timeline.vue
// module id = 636
// module chunks = 0 1